import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'
import Web3 from 'web3';

import { CURR_NET } from '../constants';
import GamePage from './GamePage.js';
import PastBoard from './PastBoard.js';
import About from './About.js';
import HashHeroList from './HashHeroList';
import NoMatch from './NoMatch';
import Background from './Background.js';
import './App.css';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            web3: null,
            web3Retries: 0,
            hasMetaMask: false,
        }
    }

    checkWeb3 = () => {
        if (typeof window.web3 !== 'undefined') {
            this.setState({
                web3: window.web3,
                hasMetaMask: true,
            });
        } else {
            if (this.state.web3Retries > 3) {
                const web3 = new Web3(new Web3.providers.HttpProvider(CURR_NET));
                this.setState({
                    web3,
                });
                return;
            }

            this.setState((state) => ({
                web3Retries: state.web3Retries + 1,
            }));
            setTimeout(this.checkWeb3, 1000);
        }
    }

    componentDidMount() {
        this.checkWeb3();
    }

    render() {
        return (
            <Router>
                <div className="App">
                    <Switch>
                        <Route exact path="/" render={() => <GamePage web3={this.state.web3} />} />
                        <Route path="/boards/:gameId"
                            render={(props) =>
                                <GamePage
                                    {...props}
                                    web3={this.state.web3}
                                />
                            }
                        />
                        <Route exact path="/winners" render={() => <HashHeroList web3={this.state.web3} />}/>
                        <Route path="/games/:dimension/:gameNumber"
                            render={(props) =>
                                <PastBoard {...props}
                                    web3={this.state.web3}
                                    hasMetaMask={this.state.hasMetaMask}
                                />
                            }
                        />
                        <Route exact path="/about" render={() => <About />}/>
                        <Route component={NoMatch} />
                    </Switch>
                    <Background />
                </div>

            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js